
import { apiClient, MEAL_PLANNER_API_URL } from "."
import { GeneratorOptions, RecommenderSettings, TestingResponse } from "./types"



export async function runSimulations(recommenderSettings: RecommenderSettings, generatorOptions: GeneratorOptions) {

    return apiClient.post<TestingResponse>(`/mealPlanningTesting`, { recommenderSettings, generatorOptions }, {
        baseURL: MEAL_PLANNER_API_URL
    })
}


export const MEALS_MEALS_PARTS = {
    BREAKFAST: 'BREAKFAST',
    MIDDLE_MORNING: 'SNACK',
    LUNCH: 'LUNCH',
    MIDDLE_AFTERNOON: 'SNACK',
    DINNER: 'DINNER',
    AFTER_DINNER: 'SNACK',
}
